import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  pausas: [],
  ramais: [],
  filas: [],
  statusOperadores: [],
  operadores: [],
  permission: false,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
